import React from "react";
import SliderCom from "../helpers/SliderCom";

const logoData = [
  {
    imgSrc: require(`../../assets/images/client-logo/startupIndia.png`),
    link: "https://www.startupindia.gov.in/",
    altText: "Client Logo",
    id: 1,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/msme.png`),
    link: "https://udyamregistration.gov.in/Government-India/Ministry-MSME-registration.htm",
    altText: "Client Logo",
    id: 2,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/fav_fairs.png`),
    link: "https://favfairs.com/",
    altText: "Client Logo",
    id: 2,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/excellency-awards.png`),
    link: "https://excellency-awards.com/",
    altText: "Client Logo",
    id: 2,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/three_fingers.png`),
    link: "https://excellency-awards.com/",
    altText: "Client Logo",
    id: 2,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/dailyhunt.png`),
    link: "https://m.dailyhunt.in/news/india/english/republic+news+india-epaper-dhfacc36dfce9c4bb68db0e89d033c921b/next+cosmos+technology+upskill+tech+career+with+custom+software+development+and+online+courses-newsid-dhfacc36dfce9c4bb68db0e89d033c921b_95730ad0c1b511ee9cff2c5b153f5dff?sm=Y",
    altText: "Client Logo",
    id: 3,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/republic_newsIndia.png`),
    link: "https://republicnewsindia.com/next-cosmos-technology-upskill-tech-career-with-custom-software-development-and-online-courses/",
    altText: "Client Logo",
    id: 4,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/indiansentinel.png`),
    link: "https://indiansentinel.in/next-cosmos-technology-upskill-tech-career-with-custom-software-development-and-online-courses/",
    altText: "Client Logo",
    id: 5,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/hindustansaga.png`),
    link: "https://hindustansaga.com/next-cosmos-technology-upskill-tech-career-with-custom-software-development-and-online-courses/",
    altText: "Client Logo",
    id: 6,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/mymaharashtra.png`),
    link: "https://mymaharashtra.co.in/next-cosmos-technology-upskill-tech-career-with-custom-software-development-and-online-courses/",
    altText: "Client Logo",
    id: 7,
  },

  {
    imgSrc: require(`../../assets/images/client-logo/rkdlive.png`),
    link: "https://rkdlive.com/next-cosmos-technology-upskill-tech-career-with-custom-software-development-and-online-courses/",
    altText: "Client Logo",
    id: 8,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/gujaratjournal.png`),
    link: "https://gujaratjournal.in/next-cosmos-technology-upskill-tech-career-with-custom-software-development-and-online-courses/",
    altText: "Client Logo",
    id: 9,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/newsmint24.png`),
    link: "https://newsmint24.com/next-cosmos-technology-upskill-tech-career-with-custom-software-development-and-online-courses/",
    altText: "Client Logo",
    id: 10,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/letindiashine.png`),
    link: "https://letindiashine.com/next-cosmos-technology-upskill-tech-career-with-custom-software-development-and-online-courses/",
    altText: "Client Logo",
    id: 11,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/indianscoops.png`),
    link: "https://indianscoops.com/next-cosmos-technology-upskill-tech-career-with-custom-software-development-and-online-courses/",
    altText: "Client Logo",
    id: 12,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/metrocitynews.png`),
    link: "https://metrocitynews.in/next-cosmos-technology-upskill-tech-career-with-custom-software-development-and-online-courses/",
    altText: "Client Logo",
    id: 13,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/youthnewsexpress.png`),
    link: "https://youthnewsexpress.com/next-cosmos-technology-upskill-tech-career-with-custom-software-development-and-online-courses/",
    altText: "Client Logo",
    id: 14,
  },
  {
    imgSrc: require(`../../assets/images/client-logo/nationalage.png`),
    link: "https://nationalage.com/next-cosmos-technology-upskill-tech-career-with-custom-software-development-and-online-courses/",
    altText: "Client Logo",
    id: 15,
  },
];

export default function Sponsers() {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    speed: 1000,
    slidesToShow: 7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  return (
    <div className="client-logo-area">
      <div className="container-fluid clearfix px-70">
        <div className="logo-carousel-wrap py-90">
          <SliderCom settings={settings}>
            {logoData.map(({ imgSrc, link, altText, id }) => (
              <div className="logo-item" key={id}>
                <a href={link} target="blank">
                  <img src={imgSrc} alt={altText} />
                </a>
              </div>
            ))}
          </SliderCom>
        </div>
      </div>
    </div>
  );
}
